import {
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from '@/components/ui/sidebar'
import { getSidebarActiveDataClasses } from '@/components/sidebar/sidebar-constants'
import { cn } from '@/lib/utils'
import type { SidebarMenuSelectedStyle } from '@/types/theme'

interface SidebarDocumentItemProps {
  documentId: string
  title: string
  onClick: (documentId: string) => void
  isActive?: boolean
  selectedStyle?: SidebarMenuSelectedStyle | string | null
}

function displayTitle(title: string): string {
  const trimmed = title.trim()
  return trimmed || 'Untitled'
}

/** Pinned document row — nested under Documents when expanded. */
export function SidebarDocumentItem({
  documentId,
  title,
  onClick,
  isActive = false,
  selectedStyle,
}: SidebarDocumentItemProps) {
  const label = displayTitle(title)

  return (
    <SidebarMenuSubItem>
      <SidebarMenuSubButton
        asChild
        size="sm"
        isActive={isActive}
        className={cn(getSidebarActiveDataClasses(selectedStyle))}
      >
        <button
          type="button"
          onClick={() => onClick(documentId)}
          className="!h-auto min-h-7 !items-start [&>span:last-child]:!whitespace-normal [&>span:last-child]:!break-words"
        >
          <span
            className="min-w-0 flex-1 text-left text-xs leading-tight"
            style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}
          >
            {label}
          </span>
        </button>
      </SidebarMenuSubButton>
    </SidebarMenuSubItem>
  )
}
